import { Dialog, DialogContent } from '@/components/ui/dialog';
import type { MinimizedWorkout } from '@/stores/minimizedWorkoutStore';
import { Minus } from 'lucide-react';
import type { ReactNode } from 'react';
import { WorkoutDetail } from './WorkoutDetail';

interface WorkoutDetailDialogProps {
  workout: MinimizedWorkout | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onMinimize?: () => void;
  actions?: ReactNode;
}

export function WorkoutDetailDialog({
  workout,
  open,
  onOpenChange,
  onMinimize,
  actions,
}: WorkoutDetailDialogProps) {
  if (!workout) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0 gap-0">
        {onMinimize && (
          <button
            type="button"
            onClick={onMinimize}
            aria-label="Minimize"
            data-testid="workout-dialog-minimize"
            className="hidden sm:inline-flex absolute right-12 top-4 z-10 items-center justify-center h-7 w-7 rounded-sm text-muted-foreground opacity-70 hover:opacity-100 hover:bg-accent transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          >
            <Minus className="h-4 w-4" />
            <span className="sr-only">Minimize</span>
          </button>
        )}
        <div className="p-2">
          <WorkoutDetail workout={workout} actions={actions} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
